function toggleShowElement(btnElement, openableElements, disableBodyScroll = false) {
    if (btnElement) {
        btnElement.classList.toggle("open");
    }

    if (disableBodyScroll) {
        if (document.querySelector("body").style.overflow == 'hidden') {
            document.querySelector("body").style.overflow = "auto";
        } else {
            document.querySelector("body").style.overflow = "hidden";
        }
    }
    
    document.querySelectorAll(openableElements).forEach(el => el.classList.toggle("open"));
}

function toggleOpenElement(btnElement, selector) {
    if (btnElement) {
        btnElement.classList.toggle("open");
    }
    document.querySelector(selector).classList.toggle("open");
}

function renderComparePopup() {
    const compareObj = getCompareObject();

    Object.values(compareObj).forEach((product, index) => {
        const pdpIndex = index + 1;
        const imgEl = $(`.compare-section .images ul li:nth-child(${pdpIndex})`);
        imgEl.find(".image-element").attr('src', product.image);
        imgEl.find(".title").text(product.title);
        imgEl.find(".price").text(product.price);
        imgEl.find(".grid-product__link").attr("href", product.url);

        imgEl.find('.grid-product__colors').html("");
        product.variants.forEach((variant) => {
            const colorSwatchFallback = variant.options.split(' ').pop().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
            const colorSwatchImage = `${variant.options.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}_50x50.png`;
            imgEl.find('.grid-product__colors').append(`
                <a
                    href="${variant.url}"
                    data-variant-image="${variant.image || ''}"
                    style="background-color: ${colorSwatchFallback}; background-image: url(/cdn/shop/files/${colorSwatchImage});"
                    class="custom-color-swatch-list color-swatch color-swatch--small color-swatch--obsidian-black color-swatch--with-image"
                ></a>
            `)
        });

        $(`.compare-section .details ul li ul li:nth-child(${pdpIndex})`).html("");
        $(`.compare-section .details ul li:first-child ul li:nth-child(${pdpIndex})`).text(product.description);

        product.compare_fields.forEach((field, fieldIndex) => {
            const splited = field.split(':');
            if (splited.length == 2) {
                $(`.compare-section .details ul li:nth-child(${fieldIndex + 2}) ul li:nth-child(${pdpIndex})`).html(`${splited[0]}: <strong>${splited[1]}</strong>`);
            } else {
                $(`.compare-section .details ul li:nth-child(${fieldIndex + 2}) ul li:nth-child(${pdpIndex})`).html(field);
            }
        });

        const lastFieldIndex = product.compare_fields.length + 1;
        product.compare_field_images.forEach((image, fieldImageIndex) => {
            $(`.compare-section .details ul li:nth-child(${fieldImageIndex + lastFieldIndex}) ul li:nth-child(${pdpIndex})`).html(`<img src="${image}">`);
        });
    });

    const newVisibleClass = `visible-${Math.min(4, Object.keys(compareObj).length)}`;

    if (!$(".compare-section").hasClass(newVisibleClass)) {
        if ($(".compare-section").hasClass("collapsed")) {
            $(".compare-section").removeClass("visible-0 visible-1 visible-2 visible-3 visible-4").delay(1).queue(function(){
                $(this).addClass(newVisibleClass).dequeue();
            });
        } else {
            $(".compare-section").removeClass("visible-0 visible-1 visible-2 visible-3 visible-4").addClass(newVisibleClass).dequeue();
        }
    }

    $(".compare-section .grid-product__colors a").on("mouseenter", function() {
        const variantImage = $(this).data('variant-image');
        if (variantImage) {
            $(this).closest(".grid__item-image-wrapper").find(".image-element").attr("src", variantImage);
        }

        $(this).parent().find(".active").removeClass("active");
        $(this).addClass("active");
    })
}

function getCompareObject() {
    let compareObj = {};
    const compareStorage = sessionStorage.getItem("compare");
    if (compareStorage) {
        try {
            compareObj = JSON.parse(compareStorage);
        } catch (e) {
            console.error(e);
        }
    }

    return compareObj;
}

function saveCompareObject(compareObj) {
    sessionStorage.setItem("compare", JSON.stringify(compareObj));
}

function addToCompare(productData) {
    const compareObj = getCompareObject();

    if (typeof compareObj == 'object') {
        compareObj[productData.handle] = productData;
    } else {
        compareObj = { [productData.handle]: productData }
    }

    if (Object.keys(compareObj).length > 4) {
        delete compareObj[Object.keys(compareObj)[0]];
    }

    saveCompareObject(compareObj);
    renderComparePopup();
    $('.compare-section')[0].scrollIntoView({ behavior: 'smooth' });
}

function removeFromCompare(index0) {
    const compareObj = getCompareObject();

    delete compareObj[Object.keys(compareObj)[index0]];
    saveCompareObject(compareObj);
    renderComparePopup();
}

function showCompareDetails() {
    $('.compare-section').removeClass('collapsed');
    $('.compare-section').toggleClass('open');
    $('.compare-section')[0].scrollIntoView({ behavior: 'smooth' });
}

function compareNext() {
    const compareObj = getCompareObject();
    const compareCount = Object.keys(compareObj).length;

    if (compareCount > 2) {
        if (compareCount > 3 && $('.compare-section').hasClass('scroll-1')) {
            $('.compare-section').removeClass('scroll-1');
            $('.compare-section').addClass('scroll-2');
        }

        if ($('.compare-section').hasClass('scroll-0')) {
            $('.compare-section').removeClass('scroll-0');
            $('.compare-section').addClass('scroll-1');
        }
    }
}

function comparePrev() {
    const compareObj = getCompareObject();
    const compareCount = Object.keys(compareObj).length;

    if ($('.compare-section').hasClass('scroll-2')) {
        $('.compare-section').removeClass('scroll-2');
        $('.compare-section').addClass('scroll-1');
    } else {
        if ($('.compare-section').hasClass('scroll-1')) {
            $('.compare-section').removeClass('scroll-1');
            $('.compare-section').addClass('scroll-0');
        }
    }
}

function compareClean() {
    sessionStorage.clear();
    renderComparePopup();
    $('.compare-section').addClass('collapsed')
}

function setSwipeEvent() {
    let touchstartX = 0
    let touchendX = 0
        
    function checkDirection() {
        if (touchendX < touchstartX && touchstartX - touchendX > 50) compareNext();
        if (touchendX > touchstartX && touchendX - touchstartX > 50) comparePrev();
    }

    if (document.getElementById("compare-section")){
        document.getElementById("compare-section").addEventListener('touchstart', e => {
            touchstartX = e.changedTouches[0].screenX
        });
    
        document.getElementById("compare-section").addEventListener('touchend', e => {
            touchendX = e.changedTouches[0].screenX
            checkDirection()
        });
    }
}

setSwipeEvent();

/**
 * calls the function func once within the within time window.
 * this is a debounce function which actually calls the func as
 * opposed to returning a function that would call func.
 * 
 * @param func    the function to call
 * @param within  the time window in milliseconds, defaults to 300
 * @param timerId an optional key, defaults to func
 */
function callOnce(func, within=300, timerId=null){
    window.callOnceTimers = window.callOnceTimers || {};
    if (timerId == null) 
        timerId = func;
    var timer = window.callOnceTimers[timerId];
    clearTimeout(timer);
    timer = setTimeout(() => func(), within);
    window.callOnceTimers[timerId] = timer;
}

function addToCartBind(el) {
    el.classList.add("btn--loading");
    addToCart(el.getAttribute('data-product-id'), el.getAttribute('data-quantity')).then(() => {
        el.classList.remove("btn--loading");
    });
}

function addToCart(productId, quantity) {
    var data = {
      items: [
        {
          id: productId,
          quantity: parseInt(quantity)
        }
      ]
    };

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => {
        document.dispatchEvent(new CustomEvent("ajaxProduct:added"))
    })
    .catch((error) => {
      console.error('Error adding to cart:', error);
    });
}

$(document).ready(() => {
    if ($(".grid-product__compare").length < 1) {
        $(".compare-section").hide();
    }

    // Search button
    $(".btn-search").on("click", function(e){
        e.stopPropagation();
        $("#HeaderWrapper").toggleClass("is-search-open");
        if ($("#HeaderWrapper").hasClass("is-search-open")){
            $("#main-search").trigger("focus");
        }
    });

    $(".search-form input").on("keyup change", function(e) {
        if (e.keyCode == 13) {
            $(".search-form").submit();
            return;
        }
        callOnce(() => {
            const val = $(this).val();
            if (val.length >= 3) {
                $(".loader-container").show();
                fetch(`/search/suggest?resources[type]=product,query&resources[limit_scope]=each&resources[options][unavailable_products]=hide&q=${val}&section_id=predictive-search`)
                    .then((response) => response.text())
                    .then((html) => {
                        $(".search-form .results-container").html(html);
                        $(".loader-container").hide();
                    })
                    .catch(() => $(".loader-container").hide());
            } else {
                $(".search-form .results-container").html("");
            }
        });
    });

    $(window).click(function() {
        $("#HeaderWrapper").removeClass("is-search-open");
    });
      
    $('.search-form').click(function(e){
        e.stopPropagation();
    });
});